// extracted by mini-css-extract-plugin
module.exports = {"item":"_1fDaNhCtjd-FpXakwh9Uf3","newOrionLoading":"_16XzDHOt3VBY5SGGpiZ3ZT"};